import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';



@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class Mistral9 extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;



  product: ProductDefinition;
  seletedFoot: string = MistralFoot.Ahsap;



  defHideObjects = [
    '_yyy',

  ];

  defShowObjects =  [

    'xxx_',
    'mistral9',
  ];

  availableAnimations: AnimationDefinition[] = [];


  async created() {
    this.product = Store.getProductById('mistral9');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes,['order'],['asc']);
    this.availableAnimations =  this.product.animations as  AnimationDefinition[];
    this.availableAnimationsChanged();
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });
    if (Store.state.selection) {
      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color,element.palette,element.id);
      });

      await this.changeFoot(Store.state.selection.footAndHand);

    }  else {
      await  this.applyDefaultSelection();
    }

  }


  availableAnimationsChanged() {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }
  async changeFoot(foot:MistralFoot) {
    if (foot === MistralFoot.Plastik) {
      await this._configuratorService.hideObjects({ objects: ['mistral9_kolcak1','xxx_mistral_ayak1'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['mistral9_kolcak2','xxx_mistral_ayak2'], operator: FilterOperators.Contains });
      Store.state.selection.footAndHand = MistralFoot.Plastik;
      this.seletedFoot = MistralFoot.Plastik;
    }
    if (foot === MistralFoot.Ahsap) {
      await this._configuratorService.hideObjects({ objects: ['mistral9_kolcak2','xxx_mistral_ayak2'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['mistral9_kolcak1','xxx_mistral_ayak1'], operator: FilterOperators.Contains });
      Store.state.selection.footAndHand = MistralFoot.Ahsap;
      this.seletedFoot = MistralFoot.Ahsap;
    }
  }


  mounted() {
    // this.configuratorService = Store.state.configuratorService;

  }

  async applyDefaultSelection() {
    const selection = new Daphne9Selection();
    selection.parts = [];
    selection.footAndHand = MistralFoot.Ahsap;

    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color,element.palette,element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.palette = element.palette;
      part.name = element.name;
      selection.parts.push(part);
    });

    Store.state.selection = selection;
    await this.changeFoot(MistralFoot.Ahsap);
  }



  async colorChanged(color: any,palette: any,part: any) {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const  getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}
export class Daphne9Selection {
  parts: PartSelection[];
  footAndHand: MistralFoot;

}
export class PartSelection {
  id: string;
  palette: string;
  color: string;
  name:string;
}
enum MistralFoot {
  Plastik = 'plastik',
  Ahsap = 'ahsap',

}



// WEBPACK FOOTER //
// ./src/components/families/mistral/Mistral9.ts